import { useCallback } from 'react';
import { prop } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

import { TGetDataByAuthProps } from '@interlayer/js/app/hooks/auth/types';

export const useGetDataByAuth = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    return useCallback(({ logInData, logOutData }: TGetDataByAuthProps) => {
        return isLoggedIn ? logInData : logOutData;
    }, [isLoggedIn]);
};
